/* eslint-disable no-param-reassign */

/* eslint-disable no-param-reassign */
const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const frenchFormatter = new Intl.NumberFormat('fr-CA', {
  style: 'currency',
  currency: 'CAD',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export const formatPrice = (price: number, isFrench: boolean): string => {
  return isFrench ? frenchFormatter.format(price) : formatter.format(price);
};
